import { LocaleStrings } from '../keys';

const en: LocaleStrings = {
  nav_stories: 'STORIES',
  nav_create: 'CREATE',
  nav_login: 'Login',
  nav_home: 'Home',
  nav_search_label: 'Search',
  nav_profile: 'Profile',
  header_btn_create: 'Create Story',
  header_user_default: 'User',
  header_sign_out: 'Sign Out',
  search_placeholder: 'Search…',
  theme_toggle_light: 'Switch to Light Mode',
  theme_toggle_dark: 'Switch to Dark Mode',

  page_title_main: 'Story Craft - Main Page',
  section_browse_by_category: 'Browse by Category',
  section_explore_new_games: 'Explore New Games',
  section_popular: 'Popular',
  section_trending: 'Trending',
  section_trending_now: 'Trending Now',
  section_popular_picks: 'Popular Picks',
  section_recent_stories: 'Recent Stories',
  section_new_stories: 'New Stories',
  section_featured: 'Story Craft Featured',
  section_top_genre: 'Top {genre} Stories',
  btn_load_more_games: 'Load More Games ({count} more)',
  text_showing_games: 'Showing {visible} of {total} games',
  text_no_category_games: 'No {category} games found.',
  text_category_games: '{category} Games',
  text_error_loading_games: 'Error loading games: {error}',

  tell_us_tagline: 'Story Craft: Where fanfiction becomes playable stories.',
  tell_us_subtitle: 'Start your game today!',
  btn_create_now: 'Create Now',

  section_comments: 'Comments ({count})',
  text_no_comments: 'No comments yet. Be the first to share your thoughts!',
  btn_load_more_comments: 'Load More Comments',
  text_posting_comment: 'Posting comment...',
  text_failed_load_comments: 'Failed to load comments',
  text_login_to_view_comments: 'Login to view comments',

  page_title_game_not_found: 'Game Not Found - Story Craft',
  page_title_game_info: 'Game Info - Story Craft',
  btn_play_now: 'Play Now',
  btn_edit_story: 'Edit Story',
  btn_rate: 'Rate',
  section_about: 'About',
  section_tags: 'Tags',
  text_views: '{count} views',
  text_your_rating: 'Your rating: {rating} - {title}',
  text_game_id: 'Game ID: {id}',
  text_no_description: 'This game has no description.',
  text_game_not_found: 'Game not found',
  text_failed_load_game: 'Failed to load game information',

  section_similar_games: 'Similar Games',
  text_failed_load_similar: 'Failed to load similar games',

  hero_eyebrow: '✨ The #1 Interactive Story Creation Platform',
  hero_title: 'Zingplay Story Craft - Tell Your Story',
  hero_subtitle: 'Explore thousands of exciting stories from the creative community. Write, read, and share stories that touch hearts.',
  hero_btn_create: '🚀 Start Creating',
  hero_btn_explore: '📖 Explore Stories',
  hero_stat_stories: '12,000+ Stories',
  hero_stat_authors: '5,000+ Authors',
  hero_stat_rating: '4.9 Rating',

  prefooter_title: 'Ready to tell your story?',
  prefooter_subtitle: 'Join 5,000+ authors creating every day on StoryCraft',
  prefooter_btn_start: '🚀 Start for free',
  prefooter_btn_learn: 'Learn more →',
  footer_tagline: 'The #1 Interactive Story Creation Platform',
  footer_terms: 'Terms',
  footer_report: 'Report',
  footer_contact: 'Contact',

  section_story_craft_comments: 'Story Craft Comments - Ask and Answer here',

  translate_popup_eyebrow: 'AI TRANSLATION',
  translate_popup_title: 'Translate story to {targetLang}?',
  translate_popup_message: 'This story is in {originLang}. Do you want to open it with the {targetLang} translation?',
  translate_popup_note: 'Translations are AI-generated and may not be perfect.',
  translate_popup_btn_translate: 'Translate now',
  translate_popup_btn_keep: 'Keep original',
  translate_progress_title: 'Translating story…',
  translate_progress_subtitle: 'AI is translating to {targetLang}',
  translate_progress_step_analyze: 'Analyzing content…',
  translate_progress_step_generate: 'Generating translations…',
  translate_progress_step_pack: 'Updating language pack…',
  translate_progress_step_done: 'All done!',
  translate_progress_flavor_1: 'Reading dialogue…',
  translate_progress_flavor_2: 'Translating character lines…',
  translate_progress_flavor_3: 'Converting choices…',
  translate_progress_flavor_4: 'Syncing tone of voice…',
  translate_progress_flavor_5: 'Proofreading…',
  translate_error_title: 'Translation failed',
  translate_error_message: 'Could not translate story: {error}. The story will open in its original language.',
  translate_error_btn_ok: 'Got it',

  event_vote_section_title: 'Participating in Events',
  event_vote_btn: 'Vote',
  event_voted_btn: 'Voted',
  event_vote_count: '{count} votes',

  section_events: 'Events',
  btn_event_detail: 'Details',
  event_ranking_title: 'Story Rankings',
  event_winners_title: 'Winners',
  event_winners_subtitle: 'Top stories that won badges from this event.',

  event_time_label: 'Event Period',
  event_status_not_started: 'Starts in {days} days',
  event_status_starting_soon: 'Starts in {time}',
  event_status_ended: 'Ended',
  event_status_ongoing: '{days} days left',
  event_status_ending_soon: '{time} left',
  event_today_label: 'Today',
  event_day_elapsed: 'Day {day}',
  event_total_days: '{days} days',
  event_votes_label: 'votes',
  event_not_found: 'Event not found or has ended',
  event_not_found_sub: 'Go back to the home page to see ongoing events.',
  event_empty_stories: 'No stories have joined this event yet',
  event_empty_stories_sub: 'Be the first to publish a story and join!',
  event_modal_title: 'Join Event',
  event_modal_no_events: 'No events currently open.',
  event_modal_joined_badge: 'Joined',
  event_modal_go_to_event: 'View event',
  event_modal_join_btn: 'Join',
  event_modal_confirm_title: 'Confirm join',
  event_modal_confirm_body: 'Are you sure you want to join "{name}"? This cannot be undone.',
  event_modal_confirm_btn: 'Confirm join',

  profile_my_profile: 'My Profile',
  profile_tab_badges: 'Badges',
  profile_tab_stories: 'Stories',
  profile_tab_discussion: 'Discussion',
  profile_tab_notifications: 'Notifications',
  profile_notif_empty: 'No notifications yet.',
  profile_notif_game_approved: 'Your story has been approved.',
  profile_notif_game_rejected: 'Your story update was rejected.',
  profile_notif_new_badge: 'You earned a new badge!',
  profile_coming_soon_title: 'Coming Soon',
  profile_coming_soon_sub: 'The Badge system is being developed. Your achievements and titles will appear here.',
  profile_my_stories: 'My Stories',
  profile_stories_guest: 'Stories',
  profile_btn_new_story: 'New Story',
  profile_btn_manage: 'Manage',
  profile_btn_event: 'Event',
  profile_stat_stories: 'Stories',
  profile_stat_views: 'Total Views',
  profile_stat_star: 'Top Star',
  profile_btn_follow: 'Follow',
  profile_btn_message: 'Message',
  profile_discussion_placeholder: 'Leave a message for the author...',
  profile_discussion_login: 'Log in to comment',
  profile_btn_send: 'Send',
  profile_btn_reply: 'Reply',
  profile_btn_hide_comment: 'Hide',
  profile_btn_show_comment: 'Show',
  profile_no_comments: 'No comments yet. Be the first!',
  profile_load_more: 'Load more',
  profile_edit_title: 'Edit Profile',
  profile_edit_change_avatar: 'Change Avatar',
  profile_upload_avatar_error: 'Failed to upload avatar. Please try again.',
  profile_edit_fullname: 'Full Name',
  profile_edit_bio: 'Bio',
  profile_edit_save: 'Save',
  profile_shelf_empty: 'Your story shelf is empty',
  profile_shelf_empty_sub: 'Spin up your first interactive story in StoryCraft Studio. It only takes a few minutes to publish a draft.',
  profile_btn_create_first: 'Create your first story',
  profile_btn_load_more_stories: 'Load more stories',
  profile_save_error: 'Failed to save profile. Please try again.',
  profile_hide_error: 'Failed to hide comment.',
  profile_comment_error: 'Failed to post comment. Please try again.',
  profile_reply_error: 'Failed to post reply. Please try again.',
  profile_btn_cancel: 'Cancel',
  profile_btn_logout: 'Sign out',
  profile_logout_confirm_title: 'Sign out?',
  profile_logout_confirm_body: 'Are you sure you want to sign out of this account? You will be returned to the home page.',
  profile_login_required_title: 'Sign in required',
  profile_login_required_body: 'Sign in to view your profile, your stories and earned badges.',

  badge_achievements_title: 'Normal Achievements',
  badge_reader: 'Reader',
  badge_writer: 'Writer',
  badge_tier_locked: 'Not yet',
  badge_tier_max: 'Max level',
  badge_special_earned: '✓ Achieved',
  badge_count: '{earned} / {total} badges',
  badge_load_error: 'Failed to load data',
  badge_retry: 'Retry',
  badge_event_section: 'Event Badges',
  badge_section_normal: 'Badges',
  badge_empty: 'No badges yet',
  badge_empty_sub: 'Join events and create stories to earn your first badge.',
  badge_tier_special_label: '★ Special',
  achievement_desc_play_number_game: 'Read {count} stories',
  achievement_desc_comment_number_game: 'Leave your comment on {count} stories',
  achievement_desc_ending_seeker: 'Found the ending of {count} stories',
  achievement_desc_publish_story: 'Publish your first story',
  achievement_desc_reach_views: 'Your story reaches {count} views',
  achievement_desc_reach_number_5star_vote: 'Your story got {count} good ratings',

  rating_warn_title: 'Rated {rating}',
  rating_warn_teen_body: 'This story is rated T (Teen 13+). It may contain mild violence, suggestive themes, or content not suitable for younger readers.',
  rating_warn_mature_body: 'This story is rated M (Mature 18+). It may contain strong violence, adult themes, or other content intended for mature audiences only.',
  rating_warn_continue: 'Continue',
  rating_warn_go_back: 'Go Back',
  rating_warn_confirm_teen: 'I confirm I am 13 years or older.',
  rating_warn_confirm_mature: 'I confirm I am 18 years or older.',

  rating_section_title: 'Content Rating',
  rating_label_e: 'Everyone',
  rating_label_t: 'Teen 13+',
  rating_label_m: 'Mature 18+',
  rating_desc_e: 'Suitable for readers of all ages. Contains content appropriate for everyone.',

  hero_dialog_1: 'Harry Potter accidentally cast the wrong spell on your story again.',
  hero_dialog_2: 'Sherazade is still telling Mina one last story before sunrise…',
  hero_dialog_3: 'Sherlock Holmes noticed a missing plot hole and refused to continue loading.',
  hero_dialog_4: 'Dracula is waiting for permission to enter chapter 2.',
  hero_dialog_5: 'Frodo somehow dropped your save file into Mount Doom.',
  hero_dialog_6: 'Harry Potter and Mina are arguing over who caused the timeline collapse.',
  hero_dialog_7: 'Cinderella missed midnight again, so the loading screen got extended.',
  hero_dialog_8: 'Romeo and Juliet reached your bad ending a little too early.',
  hero_dialog_9: 'Alice opened the wrong rabbit hole and entered your draft folder.',
  hero_dialog_10: 'Mina promised not to read forbidden books anymore. Mina lied.',
  hero_dialog_11: 'Merlin is currently patching a magical bug in the story engine.',
  hero_dialog_12: 'Odysseus has been trying to reach the next chapter for 10 years.',
  hero_dialog_13: 'Dr. Frankenstein touched the codebase. Nobody feels safe anymore.',
  hero_dialog_14: 'Peter Pan refuses to let this story grow up.',
  hero_dialog_15: 'The Little Prince asked Mina why adults write so many tragic endings.',

  // AI-generated games
  section_ai_games: 'Interactive Story Games',
  section_ai_games_gradient_word: 'Interactive',
  section_ai_games_subtitle: 'Write your own dialogue, chat with NPCs and unlock infinite endings for each story',
  section_ai_games_keywords: 'chat with NPCs|infinite endings',
  badge_ai_game: 'AI Game',
  text_created_days_ago: 'Created {days}d ago',
  text_created_today: 'Created today',
  text_ai_game_disclaimer: 'This game was generated by Mina AI. Ratings, comments and similar-game discovery are not available yet.',
  text_no_ai_games: 'No AI games yet. Mina is still warming up.',
  text_failed_load_ai_games: 'Could not load AI games. Please try again.',
  page_title_ai_game: 'AI Game · Story Craft',
  btn_play_ai_game: 'Play this game',
};

export default en;
